export enum ContractType {
  paid = 'paid',
  trial = 'trial',
}
